import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Bump when regenerating media so browsers fetch fresh images.
const MEDIA_VERSION = "9";

/** Resolve a media url that may be relative (/api/media/..) to an absolute URL. */
export function asset(url) {
  if (!url) return "";
  if (url.startsWith("/api/media/") && url.includes("/raw")) {
    const sep = url.includes("?") ? "&" : "?";
    return `${BACKEND_URL}${url}${sep}v=${MEDIA_VERSION}`;
  }
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
}

export const endpoints = {
  media: (params) => api.get("/media", { params }).then((r) => r.data),
  eventTypes: () => api.get("/event-types").then((r) => r.data),
  eventType: (slug) => api.get(`/event-types/${slug}`).then((r) => r.data),
  caseStudies: () => api.get("/case-studies").then((r) => r.data),
  caseStudy: (slug) => api.get(`/case-studies/${slug}`).then((r) => r.data),
  journal: () => api.get("/journal").then((r) => r.data),
  journalPost: (slug) => api.get(`/journal/${slug}`).then((r) => r.data),
  testimonials: () => api.get("/testimonials").then((r) => r.data),
  faqs: () => api.get("/faqs").then((r) => r.data),
  createInquiry: (payload) => api.post("/inquiries", payload).then((r) => r.data),
};
